import { Card } from 'antd';
import { useEffect, useState } from 'react';
import { EmptyState } from '../../components/EmptyState';
import { ApiError } from '../../lib/http';
import { publicApi, showcasesApi } from '../../services/resources';
import type { Showcase } from '../../types/api';

export function StudentShowcasesPage() {
  const [items, setItems] = useState<Showcase[]>([]);
  const [total, setTotal] = useState<number | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    // 开展次数改走公开概览：/stats/activity-counts 是管理端接口，学生调用必然 403。
    Promise.all([
      showcasesApi.list({ page: 1, limit: 20, status: 'published' }),
      publicApi.overview().catch(() => null),
    ])
      .then(([s, o]) => {
        setItems(s.items);
        setTotal(o?.activity_total ?? null);
      })
      .catch((e) => setError(e instanceof ApiError ? `成果列表失败：${e.message}` : '成果列表失败'));
  }, []);

  if (error) return <EmptyState text={error} kind="image" />;
  if (items.length === 0) return <EmptyState text="暂无已发布成果。" kind="image" />;

  return (
    <div className="stack">
      <h1 className="page-title">成果</h1>
      {total !== null ? <p className="meta">累计开展活动 {total} 次（系统统计，非展示数字墙）</p> : null}
      {items.map((s) => (
        <Card key={s.id} title={s.title}>
          <p>{s.summary}</p>
        </Card>
      ))}
    </div>
  );
}
